/**
 * Component: SocialAuth
 * @description Provides a social authentication interface, displaying a welcome message, logo, and available sign-in options. Currently, it includes Apple Sign-In as an authentication option.
 *
 * @props
 *   @param {function} onSignInSuccess - Callback function triggered when a sign-in option, such as Apple Sign-In, is successfully completed.
 *
 * @children
 *   - AppleSignIn - Button component for Apple sign-in, passing `onSignInSuccess` to handle successful authentication.
 *
 * @layout
 *   - LogoTextContainer: Displays the Tempo logo and a welcome message with instructions.
 *   - ButtonsContainer: Contains the sign-in button(s) for social authentication.
 *
 * @example
 * <SocialAuth onSignInSuccess={() => console.log("User signed in successfully")} />
 */

import React from 'react';
import { Typography } from '@mui/material';
import logo from '../../../../../assets/logo/circle.png';
import { AppleAuth, GoogleAuth } from '../../../../../components/Auth';
import { SocialAuthContainer, LogoImage, LogoTextContainer, ButtonsContainer } from './SocialAuth.styles';

const SocialAuth = () => {
  return (
    <SocialAuthContainer>
      <LogoTextContainer>
        <LogoImage src={logo} alt="Tempo Logo" />
        <Typography variant="title2" align="center" >
          Get started by signing in
        </Typography>
        <Typography variant="bodyRegular" align="center" >
          Access all Tempo connected restaurants you work at once signed in.
        </Typography>
      </LogoTextContainer>
      <ButtonsContainer>
        <GoogleAuth />
      </ButtonsContainer>
      <ButtonsContainer>
        <AppleAuth />
      </ButtonsContainer>
    </SocialAuthContainer>
  );
};

export default SocialAuth;
